<template>
    <div class="col-12 nopads">
        <top-bar :current-view="views.TEAM_INFO_VIEW" @onSignInClicked="showLogin"/>
        <alert
                :show="alertVisible"
                :message="message"
                :variant="variant"
                @alertShown=alertShown
        />
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <div v-if="!showLoginForm" class="mx-auto">
                    <bread-crumbs :breadcrumbs="this.breadcrumbs" />
                    <b-container v-if="team" class="mb-4 pl-0 pr-0">
                        <!-- <div class="content-header-container"
                             v-bind:style="{ backgroundImage: 'url(' + teamBackgroundImage + ')' }">
                            <div class="content-header-container-overlay">
                                <fair-image
                                    :image-id="team.logo ? team.logo.id:null"
                                    class="team-logo"
                                />
                                <transition name="fade">
                                    <div v-if="!teamBackgroundImage" class="header-img-overlay">
                                    </div>
                                </transition>
                                <h3 class="content-header-title palette-white pb-5">{{ team.name }}</h3>
                                <h4 class="content-header-subtitle palette-white">{{ team.organization.name }}</h4>
                            </div>
                        </div> -->
                        <!-- Tabs -->
                        <!-- <b-col md="12">
                            <b-row class="mt-3 mb-4">
                                <div class="col-6 nopads fair-tab-container">
                                    <div
                                        class="col-12 nopads fair-tab"
                                        v-bind:class="{ active_tab: activeTab===1}"
                                        @click.stop="setView(1)">
                                        <span class="tab-title">{{ $t('campaign.donate')}}</span>
                                    </div>
                                </div>

                                <div class="col-6 nopads fair-tab-container">
                                    <div
                                        class="col-12 nopads fair-tab"
                                        v-bind:class="{ active_tab: activeTab===2}"
                                        @click.stop="setView(2)">
                                        <span class="tab-title">{{ $t('common.info')}}</span>
                                    </div>
                                </div>
                            </b-row>
                        </b-col> -->
                        <!-- Team campaigns -->
                        <div v-if="activeTab === 1" >
                            <!--<b-container class="mt-6 mb-3 pl-0 pr-0">
                                <b-col lg="12" class="no-gutters">
                                    <h3 class="info-subtitle palette-primary">{{ team.name }}</h3>
                                </b-col>
                            </b-container>-->
                            <b-container class="mb-4 pl-0 pr-0">
                                <b-col lg="12" class="no-gutters">
                                    <h3>{{ $t("common.sport_donation_targets") }}</h3>
                                </b-col>
                            </b-container>
                            <campaign-feed :team-id="team.id"/>
                        </div>
                        <!--<div v-if="activeTab === 2">
                            <b-col md="8" offset-md="2">
                                <h3 class="info-subtitle palette-primary mt-5 mb-3">{{ team.name}}</h3>
                                <span class="title">{{ $t('campaign.organization')}}</span>
                                <p class="p-small">{{ team.organization.name }}</p>
                                <span class="title">{{ $t('organization.phone')}}</span>
                                <p class="p-small">{{ team.organization.phone }}</p>
                                <span class="title">{{ $t('organization.address')}}</span>
                                <p class="p-small">{{ team.organization.address.street_address }}, {{ team.organization.address.postal }} {{team.organization.address.city }}</p>
                                <p class="p-small">{{ team.description }}</p>
                            </b-col>
                        </div>-->
                    </b-container>
                    <b-container v-else>
                        <no-results v-if="!loading"/>
                    </b-container>
                </div>
            </div>
            <footer-area />
        </div>
        <login v-if="showLoginForm"
               @loginUser="hideLogin"
               @close="hideLogin"
               @alert="showAlert">
        </login>
        <div v-if="loading"
             id="loader"
             class="spinner">
        </div>
    </div>
</template>
<script>
    import CampaignFeed from "../components/feed/CampaignFeed";
    import {userHelper} from "../mixins/UserMixin";
    import {views} from "../mixins/ViewMixin";
    import TopBar from "../components/TopBar";
    //import FairImage from "../components/FairImage";
    import FairApi from "../modules/api";
    import Login from "../components/Login";
    import NoResults from "../components/NoResults";
    import Alert from "../components/Alert";
    import {alertMixin} from "../mixins/AlertMixin";
    import FooterArea from "../components/FooterArea";
    import BreadCrumbs from "@/components/BreadCrumbs";

    export default {
        name: "team-info-view",
        mixins: [userHelper, views, alertMixin],
        components: {BreadCrumbs, Alert, NoResults, Login, TopBar, CampaignFeed, FooterArea}, // FairImage,
        props: {
            teamInfo: {
                type: Object,
                default: null
            },
            id: {
                type: [Number, String],
                default: 0
            }
        },

        data() {
            return {
                views,
                activeTab: 1,
                teamBackgroundImage: null,
                showLoginForm: false,
                team: null,
                loading: false,
                breadcrumbs: []
            }
        },
        created() {
            if (!this.teamInfo) {
                this.fetchTeams()
            } else {
                this.team = this.teamInfo
                this.fetchBackgroundImage()
                this.setBreadcrumbs()
            }
        },
        methods: {
            fetchTeams: function () {
                this.loading = true
                FairApi.get(FairApi.teamById(this.id), this.successTeam, this.fail)
            },

            successTeam: function (response) {
                this.team = response
                this.loading = false
                this.fetchBackgroundImage()
                this.setBreadcrumbs()
            },

            fail: function () {
                this.loading = false
                this.showAlert(this.$t('common.fetch_failed'))
            },

            setBreadcrumbs: function () {
                this.breadcrumbs = [
                    {
                        text: "breadcrumbs.front_page",
                        translate: true,
                        route: 'main-view',
                        disabled: false,
                        active: false
                    },
                    {
                        text: "categories." + this.team.organization.category,
                        translate: true,
                        route: 'category-organizations-view',
                        disabled: false,
                        active: false,
                        params: { id: this.team.organization.category }
                    },
                    {
                        text: this.team.organization.name,
                        translate: false,
                        route: 'organization-campaigns-view',
                        disabled: false,
                        active: false,
                        params: { id: this.team.organization.id }
                    },
                    {
                        text: this.team.name,
                        translate: false,
                        route: 'team-info-view',
                        disabled: true,
                        active: true
                    },
                ]
            },

            fetchBackgroundImage: function () {
                if (this.team.background) {
                    this.loading = true
                    FairApi.get(FairApi.photo(this.team.background.id), this.successImage, this.fail)
                }
            },

            successImage: function (response) {
                this.teamBackgroundImage = response
                this.loading = false
            },

            setView: function (tab) {
                this.activeTab = tab
            },

            showLogin: function () {
                this.showLoginForm = true
            },

            hideLogin: function () {
                this.showLoginForm = false
            }
        }
    }
</script>

<style scoped>
</style>